angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('404.html',
    '<!DOCTYPE html>\n' +
    '<html lang="en">\n' +
    '\n' +
    '<head>\n' +
    '    <meta charset="utf-8">\n' +
    '    <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1,user-scalable=no">\n' +
    '    <!--[if ie]><meta http-equiv="X-UA-Compatible" content="IE=edge"><![endif]-->\n' +
    '    <meta name="description" content="P.E. For Hire, about">\n' +
    '    <meta name="keywords" content="">\n' +
    '    <title>P.E. For Hire | 404</title>\n' +
    '    <link rel="shortcut icon" href="img/favicon.ico">\n' +
    '    <link rel="icon" type="image/png" href="img/favicons.png">\n' +
    '    <link rel="stylesheet" href="http://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css">\n' +
    '    <link rel="stylesheet" href="http://maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css">\n' +
    '    <link rel="stylesheet" href="css/bootstrap.min.css">\n' +
    '    <!-- Remove from LIVE version -->\n' +
    '    <link rel="stylesheet" href="css/font-awesome.min.css">\n' +
    '    <!-- Remove from LIVE version -->\n' +
    '    <link rel="stylesheet" href="css/style.css">\n' +
    '    <link rel="stylesheet" href="css/bootstrap-datepicker.css">\n' +
    '    <!-- Anti-spam mail -->\n' +
    '    <script>\n' +
    '        function maillink(lhs, rhs) {\n' +
    '            document.write("<a href=\\"mailto");\n' +
    '            document.write(":" + lhs + "@");\n' +
    '            document.write(rhs + "\\" >" + lhs + "@" + rhs + "<\\/a>");\n' +
    '        }\n' +
    '    </script>\n' +
    '</head>\n' +
    '\n' +
    '<body id="body">\n' +
    '\n' +
    '    <!-- Header -->\n' +
    '    <header id="top-menu" class="navbar navbar-fixed-top">\n' +
    '        <div class="container-fluid">\n' +
    '            <div class="navbar-header">\n' +
    '                <a class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse"></a>\n' +
    '                <a href="index.htm" class="logo">\n' +
    '                    <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                        <polygon class="pol-a" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53" />\n' +
    '                        <polygon class="pol-b" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7" />\n' +
    '                        <polygon class="pol-c" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3" />\n' +
    '                    </svg>\n' +
    '                    <div>\n' +
    '                        <strong>pe</strong><span>4</span>h</div>\n' +
    '                </a>\n' +
    '            </div>\n' +
    '            <nav id="my-nav" class="navbar-collapse collapse">\n' +
    '                <ul class="nav navbar-nav">\n' +
    '                    <li>\n' +
    '                        <a href="first-project.htm">post project</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href="" ui-sref="signup">join as an engineer</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href="first-step.htm">sign up</a>\n' +
    '                    </li>\n' +
    '                    <li>\n' +
    '                        <a href="login.htm" class="btn btn-primary">log in</a>\n' +
    '                    </li>\n' +
    '                </ul>\n' +
    '            </nav>\n' +
    '        </div>\n' +
    '    </header>\n' +
    '\n' +
    '    <!-- Top Display -->\n' +
    '    <section class="content display about parallax" style="background-image:url(\'img/engineer-mesuring-land.jpg\')">\n' +
    '        <div class="gradient">\n' +
    '            <div class="container">\n' +
    '                <h1 style="font-size:150px;">404</h1>\n' +
    '                <h3>Error</h3>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </section>\n' +
    '\n' +
    '    <!-- Footer -->\n' +
    '    <footer id="footer">\n' +
    '        <div class="container-fluid">\n' +
    '            <div class="row">\n' +
    '                <div class="col-xs-6 col-sm-9">\n' +
    '                    <div class="row nav-footer">\n' +
    '                        <div class="col-xs-12 col-sm-2">\n' +
    '                            <a href="index.htm" class="logo">\n' +
    '                                <svg class="symbol" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.2 70.7">\n' +
    '                                    <polygon class="pol-a" points="44.4 43.3 44.4 43.3 30.6 51.3 16.8 43.3 16.8 43.3 0 53 30.6 70.7 61.2 53" />\n' +
    '                                    <polygon class="pol-b" points="30.6 0 30.6 19.4 44.4 27.4 44.4 43.3 61.2 53 61.2 17.7" />\n' +
    '                                    <polygon class="pol-c" points="16.8 27.4 30.6 19.4 30.6 0 0 17.7 0 53 16.8 43.3" />\n' +
    '                                </svg>\n' +
    '                            </a>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-3 col-lg-2">\n' +
    '                            <h5>\n' +
    '                                <a href="about.htm">About</a>\n' +
    '                            </h5>\n' +
    '                            <ul class="nav nav-pills nav-stacked">\n' +
    '                                <li>\n' +
    '                                    <a href="about.htm#company">Company</a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="about.htm#contact">Contact</a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-3 col-lg-2">\n' +
    '                            <h5>\n' +
    '                                <a href="resources.htm">Resources</a>\n' +
    '                            </h5>\n' +
    '                            <ul class="nav nav-pills nav-stacked">\n' +
    '                                <li>\n' +
    '                                    <a href="resources.htm#how-it-works">How it Works</a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="resources.htm#faq">FAQ</a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                        <div class="col-xs-12 col-sm-4 col-lg-3">\n' +
    '                            <h5>\n' +
    '                                <a href="privacy.htm">Legal</a>\n' +
    '                            </h5>\n' +
    '                            <ul class="nav nav-pills nav-stacked">\n' +
    '                                <li>\n' +
    '                                    <a href="privacy.htm">Privacy Policy</a>\n' +
    '                                </li>\n' +
    '                                <li>\n' +
    '                                    <a href="terms.htm">Terms and Conditions</a>\n' +
    '                                </li>\n' +
    '                            </ul>\n' +
    '                        </div>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="col-xs-6 col-sm-3">\n' +
    '                    <div class="share-icons">\n' +
    '                        <a href="https://www.facebook.com/PEForHire/" target="_blank" class="fa fa-facebook-official"></a>\n' +
    '                        <a href="https://twitter.com/PEForHire" target="_blank" class="fa fa-twitter"></a>\n' +
    '                        <a href="https://www.linkedin.com/company/pe-for-hire" target="_blank" class="fa fa-linkedin"></a>\n' +
    '                    </div>\n' +
    '                </div>\n' +
    '                <div class="clearfix"></div>\n' +
    '                <div class="col-sm-12 mt40">\n' +
    '                    <small class="copyright">\n' +
    '                        <noscript>2016</noscript>\n' +
    '                        <script>\n' +
    '                            document.write(new Date().getFullYear())\n' +
    '                        </script> P.E. For Hire, LLC. All Rights Reserved.</small>\n' +
    '                </div>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </footer>\n' +
    '\n' +
    '    <!-- To Top -->\n' +
    '    <div class="back-to-top"></div>\n' +
    '\n' +
    '    <!-- Bootstrap Scripts -->\n' +
    '    <script src="http://code.jquery.com/jquery-1.12.4.min.js"></script>\n' +
    '    <script src="http://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/js/bootstrap.min.js"></script>\n' +
    '\n' +
    '    <!-- Jquery Scripts -->\n' +
    '    <script src="js/jquery.easing.js"></script>\n' +
    '\n' +
    '    <!-- Utility Scripts -->\n' +
    '    <script src="js/scripts.js"></script>\n' +
    '    <script src="js/modernizr.js"></script>\n' +
    '    <script src="js/classie.js"></script>\n' +
    '\n' +
    '    <!-- Responsive for IE8 -->\n' +
    '    <script src="js/respond.min.js"></script>\n' +
    '\n' +
    '    </script>\n' +
    '\n' +
    '</body>\n' +
    '\n' +
    '</html>');
}]);
